import AppCopy from "copy/AppCopy";
import React from "react";

function LiveCarStaffHeader() {
  const { carNoText, assignedText, CustomerText, statusText } =
    AppCopy.oneStaffPage;

  return (
    <div className={Classname.container}>
      <span className={Classname.carNo}>{carNoText}</span>
      <span className={Classname.asigned}>{assignedText}</span>
      <span className={Classname.status}>{statusText}</span>
      <span className={Classname.customer}>{CustomerText}</span>
    </div>
  );
}

export default LiveCarStaffHeader;

const Classname = {
  container:
    "w-full border-b hidden sm:flex items-center justify-between text-sm text-secondaryText py-2",
  carNo: "w-1/5",
  asigned: "w-1/5",
  status: "w-1/5 ",
  customer: "w-1/5 ",
  detail: "w-1/5",
};
